/**
 * Embed Axios Interceptor
 * 
 * Configures axios to use embed access tokens for API requests.
 * Handles token expiration and refresh flow.
 */

import baseAxios from '@/shared/utils/request';
import { isInIframe } from '@/shared/contexts/EmbedAuthContext';
import { getAccessToken } from '@/shared/utils/embedTokenManager';

let interceptorSetup = false;

/**
 * Setup axios interceptor for embed mode
 */
export const setupEmbedInterceptor = () => {
    if (interceptorSetup) return;

    interceptorSetup = true;

    // Request interceptor - add embed access token
    baseAxios.interceptors.request.use(
        (config) => {
            if (!isInIframe()) return config;

            const token = getAccessToken();

            if (token) {
                console.log('[EmbedInterceptor] Attaching token to request:', config.url);
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                console.log('[EmbedInterceptor] No token found for request:', config.url);
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response interceptor - handle 401
    baseAxios.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;

            if (!isInIframe()) return Promise.reject(error);

            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;

                console.log('[EmbedInterceptor] 401 received, requesting token refresh from parent...');
                window.parent.postMessage({ type: 'TOKEN_EXPIRED' }, '*');

                return Promise.reject(error);
            }

            return Promise.reject(error);
        }
    );

    console.log('[EmbedInterceptor] Interceptor configured');
};

export default setupEmbedInterceptor;
